import React, { Fragment } from 'react'

// icons
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons'

// styles
import './Departamento.css'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemDepartamentoEliminado from './ItemDepartamentoEliminado'

// services

// route
import { withRouter } from 'react-router-dom'
import Header from '../Header/Header'
import routes from '../../Routes'

// alert swal
import usePagination from './hooks/usePagination'
import HeaderPagination from '../Custom/HeaderPagination'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'

const visibleButtons = {
    create: false,
    import: false,
    export: false,
    deleted: false,
    search: true,
}

function DepartamentoEliminados({ history }) {
    const {
        page,
        totalRegister,
        totalPage,
        setIsLoad,
        departamentos,
        nextPage,
        previousPage,
        handleBuscador,
    } = usePagination(history, false)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faLayerGroup}
                        title={'Departamentos Eliminados'}
                    />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.DEPARTAMENTO}
                    visibleButtons={visibleButtons}
                    handleBuscador={handleBuscador}
                />

                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Codigo</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">IVA</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {departamentos.map((departamento) => (
                            <ItemDepartamentoEliminado
                                key={parseInt(departamento.id)}
                                departamento={departamento}
                                setIsLoad={setIsLoad}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(DepartamentoEliminados)
